import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import workOrderApi from '../../../api/workOrderApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'workOrders';

export const CreateWorkOrder = createAsyncThunk<any, any, { rejectValue: { status: string; message: string } }>(
  `${REDUCER_NAME}/createWorkOrder`,
  async (data, thunkAPI) => {
    const res = await workOrderApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching work order' });
  }
);

export const GetWorkOrders = createAsyncThunk(`${REDUCER_NAME}/getWorkOrders`, async (__, thunkAPI) => {
  const res = await workOrderApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching work order' });
});

export const GetWorkOrderById = createAsyncThunk<any, string, { rejectValue: { status: string; message: string } }>(
  `${REDUCER_NAME}/getWorkOrderById`,
  async (id, thunkAPI) => {
    const res = await workOrderApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching work order' });
  }
);

export const UpdateWorkOrder = createAsyncThunk<
  any,
  { data: any; id: string },
  { rejectValue: { status: string; message: string } }
>(`${REDUCER_NAME}/updateWorkOrder`, async ({ data, id }, thunkAPI) => {
  const res = await workOrderApi.update(data, id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching work order' });
});

// export const ImportUsers = createAsyncThunk(`${REDUCER_NAME}/importUsers`, async (data, thunkAPI) => {
//   const res = await distributorApi.importUsers(data);

//   if (res.status === 200) return res.data;

//   return thunkAPI.rejectWithValue("Fetch error");
// });
